import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import FileSaver from "file-saver";
import { Spin, Table, DatePicker } from "antd";
import moment from "moment";

import AuthRender from "../../containers/AuthRender";
import { setMenuTopIndex } from "../../redux/actions/menuActions";
import { ACCESS, SERVICES } from "../../configs/constants";
import { currentClientSelector } from "../../redux/selectors/auth";
import { selectUserRoleId } from "../../redux/selectors/user";
import { getKpis } from "../stats/sagas";
import { getExportFile, getExportRawFile } from "../stats/sagas/summary";
import { handleError } from "../presence/sagas";
import Dimensions from "./DimensionsDownload";
import { columns } from "./downloadstats.utils";

const StatsDownload = ({ setMenuTopIndex, currentClient, userRoleId }) => {
  const { id: currentClientId } = currentClient;
  const [kpis, setKpis] = useState([]);
  const [period, setPeriod] = useState([moment().startOf("month"), moment().endOf("day")]);
  const [isLoading, setIsLoading] = useState(false);
  const [dimensions, setDimensions] = useState(["global"]);

  const exportData = async (kpi, key = "full") => {
    setIsLoading(true);
    try {
      const body = {
        filters: {
          id: "Globale",
          data: {
            p_visit_statement: ["end"],
            p1_visit_statement: ["end"],
            p_visit_target: ["last"],
            p1_visit_target: ["last"],
            gain_compare_type: ["all"],
            // product_range_properties: ["O"],
            client_id: [currentClientId]
          }
        },
        period: period,
        period1: null,
        summaryKpiId: kpi.id,
        dimensions: dimensions
      };
      let data = [];
      if (key === "full") {
        data = await getExportFile(kpi.id, body);
      } else {
        data = await getExportRawFile(kpi.id, body);
      }
      FileSaver.saveAs(new Blob([data], { type: "application/vnd.ms-excel" }), `${kpi.long_label || "Données"}.xlsx`);
    } catch (e) {
      console.log(e);
      handleError(e);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchKpisList = async () => {
    try {
      setIsLoading(true);
      const body = {
        match: {
          client_id: currentClient.id
        },
        sort: { priority: 1, id: 1 }
      };
      const kpis = await getKpis(body);
      setKpis(kpis);
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    setMenuTopIndex("downloadstats");
    fetchKpisList();
  }, []);
  if (userRoleId > 3) {
    return null;
  }
  return (
    <div>
      <div class="bg-gray-100 p-8 rounded-lg shadow-md">
        <h1 class="text-2xl font-semibold mb-4">Téléchargement des stats sans affichage préalable des graphiques</h1>
        <div class="bg-white p-6 rounded-lg shadow-md">
          <h2 class="text-xl font-medium mb-3 text-gray-700">Page en cours d'élaboration</h2>
          <div class="text-gray-600 mb-3 italic">TODO</div>
          <ul class="list-disc pl-5">
            <li class="text-gray-600">Choix des dimensions (enseigne, point de vente...)</li>
            <li class="text-gray-600">Filtres (point de vente, secteur...)</li>
          </ul>
        </div>
      </div>
      <div class="flex justify-center py-4">
        <DatePicker.RangePicker
          className="form-input rounded-md shadow-sm border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
          value={period}
          format="DD/MM/YYYY"
          allowClear={false}
          onChange={setPeriod}
        />
      </div>
      <div>
        <Dimensions displayMaxOrder={0} loading={isLoading} onChange={setDimensions} />
      </div>
      <AuthRender service={SERVICES.Statistiques} access={ACCESS.export}>
        {isLoading ? (
          <Spin />
        ) : (
          <Table rowKey="_id" columns={columns(exportData)} dataSource={kpis} pagination={false} align="center" />
        )}
      </AuthRender>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    currentClient: currentClientSelector(state),
    userRoleId: selectUserRoleId(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StatsDownload));



// WEBPACK FOOTER //
// src/modules/downloadstats/index.js